import {Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {UtilitiesService} from "../../services/utilities.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-foto-entrega-view',
  templateUrl: './foto-entrega-view.component.html',
  styleUrls: ['./foto-entrega-view.component.scss']
})
export class FotoEntregaViewComponent  {

  image_view_src:string = '';
  signed_public_dir:string = '';
  constructor(public dialog: MatDialog, private router: Router,public utilityService : UtilitiesService,
              private dialogRef: MatDialogRef<FotoEntregaViewComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
  }

  ngOnInit(): void {

    const canvas = document.getElementById('img_canvas') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    this.image_view_src = `${environment.api_host}/firmas/${this.data.sg123}.png`;

    const img = new Image();
    img.src = this.image_view_src;

    const image_container = document.getElementById('image-view') as HTMLDivElement;

    img.height = image_container.clientHeight;
    img.width = image_container.clientWidth;

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
    };



  }

  closeDialog(){
    this.dialogRef.close();
  }

}
